import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { REPLACE_LOCATION_TYPE_MUTATION } from '../graphql/mutations'
import { REPLACE_LOCATION_TYPE } from '../redux/action-types'

const useReplaceLocationTypeMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.locationTypes.locationTypesAndLocationTypeCategories,
  )

  const mutate = useCallback(
    async ({ idToReplace, replacementId }) => {
      await apolloService.mutate(
        REPLACE_LOCATION_TYPE_MUTATION,
        {
          idToReplace,
          replacementId,
        },
        dispatch,
        REPLACE_LOCATION_TYPE,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useReplaceLocationTypeMutation
